import React from 'react';
import ReactDOM from 'react-dom';

const Dialog = ({ title, children, buttons, width, height, isOpen, overflow }) => {
  
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-overlay" role="dialog" aria-modal="true" style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex',
            justifyContent: 'center', alignItems: 'center'
        }}>
            <div className="modal-content" style={{ width: `${width}px`, height: `${height}px`, background: '#fff', padding: '15px', position: 'relative', overflow: overflow }}>
                <div className="modal-header">
                    <span style={{ fontWeight: 'bold' }}>{title}</span>
                </div>
                <div className="modal-body">
                    {children}
                </div>
                <div className="modal-footer" style={{ textAlign: 'right' }}>
                    {buttons.map((btn, i) => (
                        <button key={i} onClick={btn.onClick} style={{ marginLeft: '5px' }}>
                            {btn.text}
                        </button>
                    ))}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Dialog;